<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">Add Role to Api
              <form
                class="roleDropdown"
                @submit.prevent=""
              >
                <b-form-select
                  id="statusFilter"
                  v-model="roleSelection"
                  class="full-width"
                  @change.native="onChange"
                >
                  <option
                    v-for="api in APIs"
                    v-bind="$attrs"
                    :key="api.apiID"
                    :value="api.apiID"
                  >
                    {{ api.apiName }}
                  </option>
                </b-form-select>
              </form>
            </span>
          </div>

          <b-table
            striped
            hover
            :items="userRoles"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template
              slot="id"
              slot-scope="data"
            >
              <!--<b-form-checkbox v-model="roleID" @change=""></b-form-checkbox>-->
              <b-form-checkbox
                v-model="checkedAPIs"
                :plain="true"
                value="data.item.id"
                unchecked-value="0"
                :value="data.item.id"
                @change.native="clickHandler"
              />
            </template>
          </b-table>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import addRole2ApiMixin from '../mixins/addRole2ApiMixin'

export default {
  name: 'AddRole2Api',
  mixins: [addRole2ApiMixin]
}
</script>
<style media="screen">

  td.width-250 {
    width: 250px;
    max-width: 250px;
  }

  .roleDropdown {
    width: 250px;
    max-width: 250px;
    display: inline-block;
  }

</style>
